module.exports = __webpack_public_path__ + "img/wep_spear02.e9466687.png";